var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopyResult(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heroicons-mini/document-duplicate"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.4001 4.19999C8.4001 3.20588 9.20598 2.39999 10.2001 2.39999H14.8545C15.3319 2.39999 15.7897 2.58964 16.1273 2.9272L19.8729 6.67279C20.2105 7.01035 20.4001 7.46819 20.4001 7.94558V15C20.4001 15.9941 19.5942 16.8 18.6001 16.8H17.4001V12.7456C17.4001 11.7908 17.0208 10.8751 16.3457 10.2L12.6001 6.45441C11.925 5.77928 11.0093 5.39999 10.0545 5.39999H8.4001V4.19999Z",
    fill: "#6B7280"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.4001 7.19999C4.40599 7.19999 3.6001 8.00588 3.6001 8.99999V19.8C3.6001 20.7941 4.40598 21.6 5.4001 21.6H13.8001C14.7942 21.6 15.6001 20.7941 15.6001 19.8V12.7456C15.6001 12.2682 15.4105 11.8104 15.0729 11.4728L11.3273 7.7272C10.9897 7.38964 10.5319 7.19999 10.0545 7.19999H5.4001Z",
    fill: "#6B7280"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyResult);
export default __webpack_public_path__ + "static/media/copy_result.ef3a3cb23f1b10212745d9405590a431.svg";
export { ForwardRef as ReactComponent };